import React, { useState, useEffect } from "react";
import Header from "../Header/Header";
import Asidebar from "../Header/Asidebar";
import { InfinitySpin } from "react-loader-spinner";
import { Link, useNavigate } from "react-router-dom";
import { deleteData, postData } from "../../FetchNodeServices";
import AlertMessages from "../Mains/Alerts";
import { useSelector, useDispatch } from "react-redux";
import { deleteSubUser } from "../../redux/subuserSlice";
import { addSubuser } from "../../redux/subuserSlice";
import CreatableSelect from "react-select/creatable";

const ConnectClientDatabase = () => {
  const [isActivated, setIsActivated] = useState(true);
  const [fullWidthWrapper, setFullWidthWrapper] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [clientName, setClientName] = useState("Client")
  const [username, setUserName] = useState("tdbusr");
  const [password, setPassword] = useState("IrBLzt-st@20");
  const [url, setUrl] = useState("jdbc:mysql://184.95.54.139:3306/capacity_client_connect?useSSL=false&serverTimezone=UTC");
  const [databasedriverOptions, setDataBaseDriverOptions] = useState([]);
  const [databasedriver, setDataBaseDriver] = useState(null);
  const dispatch = useDispatch("");
  const [alerts, setAlerts] = useState([]);
  const client = useSelector((state) => state.subuser.subusers[0]);

  let navigate = useNavigate();

  // Fetch teams from backend on component mount
  useEffect(() => {
    const fetchdatabasedriverOptions = async () => {
      try {
        const databaseOptions = [
          { value: 'com.mysql.cj.jdbc.Driver', label: 'MySQL' },
          { value: 'com.microsoft.sqlserver.jdbc.SQLServerDriver', label: 'MSSQL' },
          { value: 'org.postgresql.Driver', label: 'Oracle' },
          { value: 'oracle.jdbc.OracleDriver', label: 'PostgreSQL' },
        ];
        setDataBaseDriverOptions(databaseOptions);
      } catch (error) {
        console.error("Error fetching teams:", error);
      }
    };

    fetchdatabasedriverOptions();
  }, []);

  const handleToggle = () => {
    setIsActivated(!isActivated);
    setFullWidthWrapper(isActivated ? "fullwrapper" : "");
  };



  const handleSubmit = async () => {
    if (!username || !password || !databasedriver || !url) {
      setAlerts([
        {
          variant: "danger",
          heading: "Please fill all the required fields correctly!",
        },
      ]);
      return;
    }

    var formData = {
      clientName: clientName,
      driverName: databasedriver.value,
      username: username,
      password: password,
      databaseUrl: url,
    };


    var result = await postData("users/connect-client-database", formData);
    if (result) {
      navigate("/panel-management");
      dispatch(addSubuser(result));
    }

  }

  const handleDisconnect = async () => {
    var result = await deleteData(`users/disconnect-client-database?datasource=${client}`);
    if (result) {
      navigate("/panel-management")
      dispatch(deleteSubUser(client));
    }
  }

  const customComponents = {
    DropdownIndicator: null,
    IndicatorSeparator: null,
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: "38px",
      borderColor: "#ced4da",
      "&:hover": {
        borderColor: "#80bdff",
      },
      boxShadow: "none",
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: "0 6px",
    }),
    input: (provided) => ({
      ...provided,
      margin: 0,
      padding: 0,
    }),
    singleValue: (provided) => ({
      ...provided,
      margin: 0,
      padding: 0,
    }),
  };

  // Function to handle new team creation or selection
  const handledatabasedriverChange = (newValue, actionMeta) => {
    if (actionMeta.action === "create-option") {
      const newdatabasedriver = { value: newValue.value, label: newValue.value };
      setDataBaseDriver(newdatabasedriver);
      setDataBaseDriverOptions([...databasedriverOptions, newdatabasedriver]);
    } else if (actionMeta.action === "select-option") {
      setDataBaseDriver(newValue);
    }
  };

  return (
    <div>
      <Asidebar isActivated={isActivated} />
      <div id="wrapper" className={fullWidthWrapper}>
        <Header onclick={handleToggle} />
        {isLoading && (
          <div className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center" style={{ zIndex: 1050 }}>
            <div className="p-5 rounded">
              <InfinitySpin visible={true} width="200" color="#4fa94d" ariaLabel="infinity-spin-loading" />
            </div>
          </div>
        )}
        <div id="page_wrapper" className="py-3">
          <div className="card p-3 border-light-subtle mb-3">
            <ul className="breadcrumb m-0">
              <li>
                <Link to="/dashboard">
                  <i className="bi bi-people"></i> Dashboard
                </Link>
              </li>
              <li>
                <span className="breadcrumb_slash">/</span>
                <i className="bi bi-people"></i> Panel Management
              </li>
              <li>
                <span className="breadcrumb_slash">/</span>
                <i className="bi bi-app-indicator mx-2"></i> Connect Client Database
              </li>
            </ul>
            <div className="position-absolute top-0 start-0 w-100 h-100" style={{ zIndex: 1050 }}>
              <AlertMessages alerts={alerts} setAlerts={setAlerts} />
            </div>
          </div>

          <div className="card p-3 border-light-subtle">
            <div className="common_form p-3">
              <div className="row">
                <div className="col-lg-6">
                  <div className="form-group mb-4">
                    <label htmlFor="fullName">Client Name</label>
                    <input
                      type="text"
                      // value={clientName}
                      value="Client"
                      className="form-control"
                      placeholder="Enter Client Name"
                      // onChange={(event) => setClientName(event.target.value)}
                      required readOnly

                    />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group mb-4">
                    <label htmlFor="fullName">Username</label>
                    <input
                      type="text"
                      value={username}
                      className="form-control"
                      placeholder="Enter User Name"
                      onChange={(event) => setUserName(event.target.value)}
                      required
                      autoComplete="new-username"
                    />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group mb-4">
                    <label htmlFor="team">DataBase Driver Name</label>
                    <CreatableSelect
                      isClearable
                      value={databasedriver}
                      options={databasedriverOptions}
                      onChange={handledatabasedriverChange}
                      placeholder="Select or type team"
                      components={customComponents}
                      styles={customStyles}
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group mb-4">
                    <label htmlFor="email">Password</label>
                    <input
                      type="password"
                      value={password}
                      className="form-control"
                      placeholder="Enter password"
                      autoComplete="new-password"
                      required
                      onChange={(event) => setPassword(event.target.value)}
                    />

                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group mb-4">
                    <label htmlFor="email">Url</label>
                    <input
                      type="link"
                      value={url}
                      className="form-control"
                      placeholder="Enter url"
                      onChange={(event) => setUrl(event.target.value)}
                      required

                    />

                  </div>
                </div>


              </div>

              <div className="d-flex justify-content-end">
                {/* <div className="button_group">
                  <button type="button" className="btn bg-danger-subtle text-danger" onClick={() => handleClear()}>

                    Clear Values
                  </button>
                </div> */}
                {client ? (<button className="btn bg-danger-subtle text-danger " onClick={handleDisconnect}>
                  Disconnect
                </button>) : (<button className="btn btn-success px-4" onClick={handleSubmit}>
                  Connect
                </button>)} <div className="button_group">

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConnectClientDatabase;
